import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-10 md:py-16 bg-brand-900 text-white relative overflow-hidden" data-id="element-150">
      <div className="absolute inset-0 bg-brand-800 opacity-50" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-151"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-152">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center justify-center w-16 h-16 md:w-24 md:h-24 bg-brand-800 rounded-full mb-6 md:mb-8 border-2 md:border-4 border-brand-700 shadow-2xl" data-id="element-153">
          <ShieldCheck className="w-8 h-8 md:w-12 md:h-12 text-accent-400" data-id="element-154" />
        </motion.div>

        <motion.h2 initial={{
        y: 20,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-2xl md:text-5xl font-black mb-6 md:mb-8 tracking-tight" data-id="element-155">
          ✨ GARANTÍA PROFESORADO RESUELTO — 7 DÍAS
        </motion.h2>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-brand-800/80 backdrop-blur-sm rounded-xl md:rounded-2xl p-5 md:p-10 border border-brand-700 max-w-3xl mx-auto mb-6 md:mb-8 shadow-xl" data-id="element-156">
          <p className="text-sm md:text-xl font-medium text-brand-100 mb-4 md:mb-6 leading-relaxed" data-id="element-157">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás para estudiar y
            preparar tus prácticas si querés.
          </p>
          <p className="text-base md:text-2xl font-bold text-white mb-4 md:mb-6" data-id="element-158">
            Si en 7 días no es lo que esperabas: Te devolvemos el 100%.
          </p>
          <p className="text-brand-300 font-medium uppercase tracking-widest text-[10px] md:text-sm" data-id="element-159">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </motion.div>

        <p className="text-brand-200 max-w-2xl mx-auto leading-relaxed mb-5 md:mb-6 text-xs md:text-base" data-id="element-160">
          La confianza que tenemos en Profesorado Resuelto™ nos permite hacer
          esa promesa sin dudar. Más de 500 estudiantes del Profesorado de EF de
          todo el país ya lo saben.
        </p>

        <div className="inline-block bg-green-500/20 border border-green-500/30 text-green-400 font-bold px-4 py-1.5 md:px-6 md:py-2 rounded-full text-[10px] md:text-sm" data-id="element-161">
          Tasa de devoluciones menor al 1%
        </div>
      </div>
    </section>;
}